import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import RegisterPage from "./Components/Registration/Registration";
import SignInPage from "./Components/Login/Login";
import Dashboard from "./Components/dashboard/Dashboard";
import Layout from "./Components/layout/layout";
import Employees from "./Components/Employees/Employees";
import PayRuns from "./Components/Payruns/Payruns";
import LeaveRecordsTable from "./Components/LeaveRecord/LeaveRecord";
// import PayslipGenerator from './Components/Payslip/Payslip';
import ReportManagement from "./Components/Reports/Reports";
import HistoryPage from "./Components/HistoryRecord/HistoryRecord";
import Revenue from "./Components/Revenue/Revenue";
import PayslipRecord from "./Components/PayslipRecord/PayslipRecord";
import AddSalary from "./Components/SalaryManagement/Addsalary";
import PayslipData from "./Components/PayslipData/PayslipData";
import EmployeeDetails from "./Components/EmpPersonalDetail/EmpDetails";
import SetSalary from "./Components/SalaryManagement/SetSalary";
import EmployeeDetail from "./Components/Employees/EmployeeDetail";
import PayrollConfigurator from "./Components/PayrollConfigurator/PayrollConfigurator";
// Admin
// import EmpRegistration from './Admin/EmpRegistration/EmpRegistration';
import EmpList from "./Admin/EmpList/EmpList";
import UserManagement from "./Admin/UserMng/UserMng";
import Login from "./Admin/EmpRegistration/EmpLogin";
import EmployeeDetailsUnapproved from "./Components/EmpPersonalDetail/EmpAprroved";
import AddLocation from "./Components/ManageLocation/Addlocation";
import AssignLocation from "./Components/ManageLocation/AssignLocation";
import AddHours from "./Components/SalaryManagement/AddHours";
import AdminManagement from "./Components/AdminManagement/AdminManagement";
import EmployeeManagement from "./Admin/EmpList/EmpMng/EmpMng";
import PayslipManagement from "./Components/Payslip Management/PayslipMain";
import PayslipGenerator from "./Components/Payslip Management/PayslipGenerator";
import DepartmentManagement from "./Components/DepManagement/DepManagement";
// import PayslipRequest from './Components/PayslipData/PayslipRequest';

import { ToastProvider } from "./Context/ToastContext";
import EditUsersLocation from "./Components/ManageLocation/EditLocation";
import UserAuthentication from "./Components/UserAuthentication/UserAuthentication";
import PermissionChecker from "./Utils/PermissionChecker";
import LandingPage from "./Components/LandingPage/LandingPage";
import HowToUse from "./Components/HowToUse/HowToUse";
import GlobalAlert from "./Components/GlobalAlert/GlobalAlert";
import HistoryRecord from "./Components/HistoryRecord/HistoryRecord";
import AuditTrailLogs from "./Components/AuditTrailLogs/AuditTrailLogs";
import ProductLanding from "./Components/ProductLanding/ProductLanding";
import AddUser from "./Components/AddUser/AddUser";
import ProductPricing from "./Components/ProductPricing/ProductPricing";
import TermsAndConditions from "./Components/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "./Components/PrivacyAndPolicy/PrivacyAndPolicy";

function App() {
  return (
    <ToastProvider>
      <Router>
        <div className="App">
          <head>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
          </head>
          <GlobalAlert />
          <Routes>
            <Route path="/" element={<ProductLanding />} />
            <Route path="/signIn" element={<SignInPage />} />
            <Route path="/RegisterPage" element={<RegisterPage />} />
            {/* Wrap the route that needs layout with the Layout component */}
            <Route
              path="/dashboard"
              element={
                <Layout>
                  <PermissionChecker permission="dashboard">
                    <Dashboard />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/employees"
              element={
                <Layout>
                  <PermissionChecker permission="employees">
                    <Employees />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/pay-runs"
              element={
                <Layout>
                  <PayRuns />
                </Layout>
              }
            />
            <Route
              path="/leavemanagement"
              element={
                <Layout>
                  <PermissionChecker permission="leavemanagement">
                    <LeaveRecordsTable />
                  </PermissionChecker>
                </Layout>
              }
            />
            {/* <Route path='/Payslip' element={<Layout><PayslipGenerator/></Layout>}/> */}
            {/* <Route
              path="/report"
              element={
                <Layout>
                  <ReportManagement />
                </Layout>
              }
            /> */}
            <Route
              path="/History"
              element={
                <Layout>
                  <HistoryPage />
                </Layout>
              }
            />
            <Route
              path="/revenue"
              element={
                <Layout>
                  <PermissionChecker permission="revenue">
                    <Revenue />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/paysliprecord"
              element={
                <Layout>
                  <PermissionChecker permission="paysliprecord">
                    <PayslipRecord />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/addsalary"
              element={
                <Layout>
                  <AddSalary />
                </Layout>
              }
            />
            <Route
              path="/payslipdata"
              element={
                <Layout>
                  <PermissionChecker permission="payslipdata">
                    <PayslipData />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/empdetails"
              element={
                <Layout>
                  <EmployeeDetails />
                </Layout>
              }
            />
            <Route
              path="/setsalary"
              element={
                <Layout>
                  <PermissionChecker permission="setsalary">
                    <SetSalary />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/empdetail"
              element={
                <Layout>
                  <PermissionChecker permission="empdetail">
                    <EmployeeDetail />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/payrollconfigurator"
              element={
                <Layout>
                  <PermissionChecker permission="payrollconfigurator">
                    <PayrollConfigurator />
                  </PermissionChecker>
                </Layout>
              }
            />
            {/* Admin */}
            {/* <Route path='/empregistration' element={<Layout><EmpRegistration/></Layout>}/> */}
            <Route
              path="/emplist"
              element={
                <Layout>
                  <EmpList />
                </Layout>
              }
            />
            <Route
              path="/usermng"
              element={
                <Layout>
                  <PermissionChecker permission="usermng">
                    <UserManagement />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/login"
              element={
                <Layout>
                  <Login />
                </Layout>
              }
            />
            <Route
              path="/empdetailsunapproved"
              element={
                <Layout>
                  <EmployeeDetailsUnapproved />
                </Layout>
              }
            />
            <Route
              path="/addlocation"
              element={
                <Layout>
                  <PermissionChecker permission="addlocation">
                    <AddLocation />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/assignlocation"
              element={
                <Layout>
                  <PermissionChecker permission="assignlocation">
                    <AssignLocation />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/addhours"
              element={
                <Layout>
                  <PermissionChecker permission="addhours">
                    <AddHours />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/adminmanagement"
              element={
                <Layout>
                  <PermissionChecker permission="adminmanagement">
                    <AdminManagement />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/employeemanagement"
              element={
                <Layout>
                  <PermissionChecker permission="employeemanagement">
                    <EmployeeManagement />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/payslip-generate"
              element={
                <Layout>
                  <PermissionChecker permission="payslip-generate">
                    <PayslipManagement />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/payslip-generate/:salaryId"
              element={
                <Layout>
                  <PermissionChecker permission="payslip-generate">
                    <PayslipGenerator />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/DepartmentManagement"
              element={
                <Layout>
                  <DepartmentManagement />
                </Layout>
              }
            />
            <Route
              path="/EditUsersLocation"
              element={
                <Layout>
                  <PermissionChecker permission="editlocation">
                    <EditUsersLocation />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/UserAuthentication"
              element={
                <Layout>
                  <PermissionChecker permission="userauthentication">
                    <UserAuthentication />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route
              path="/LandingPage"
              element={
                <Layout>
                  <LandingPage />
                </Layout>
              }
            />
            <Route
              path="/howToUse"
              element={
                <Layout>
                  <HowToUse />
                </Layout>
              }
            />
            <Route
              path="/AuditTrailLogs"
              element={
                <Layout>
                  <PermissionChecker permission="auditlogs">
                    <AuditTrailLogs />
                  </PermissionChecker>
                </Layout>
              }
            />
            <Route path="/ProductLanding" element={<ProductLanding />} />
            <Route path="/ProductPricing" element={<ProductPricing />} />
            <Route path="/Terms" element={<TermsAndConditions />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route
              path="/AddUser"
              element={
                <Layout>
                  <AddUser />
                </Layout>
              }
            />
          </Routes>
        </div>
      </Router>
    </ToastProvider>
  );
}

export default App;
